import React from "react";
import { IconProps } from "./IconProps";

const CalendarBlankIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 2.66667H14.0833V2.08333C14.0833 1.92862 14.0219 1.78025 13.9125 1.67085C13.8031 1.56146 13.6547 1.5 13.5 1.5C13.3453 1.5 13.1969 1.56146 13.0875 1.67085C12.9781 1.78025 12.9167 1.92862 12.9167 2.08333V2.66667H7.08333V2.08333C7.08333 1.92862 7.02187 1.78025 6.91248 1.67085C6.80308 1.56146 6.65471 1.5 6.5 1.5C6.34529 1.5 6.19692 1.56146 6.08752 1.67085C5.97812 1.78025 5.91667 1.92862 5.91667 2.08333V2.66667H4.16667C3.85725 2.66667 3.5605 2.78958 3.34171 3.00838C3.12292 3.22717 3 3.52391 3 3.83333V15.5C3 15.8094 3.12292 16.1062 3.34171 16.325C3.5605 16.5438 3.85725 16.6667 4.16667 16.6667H15.8333C16.1428 16.6667 16.4395 16.5438 16.6583 16.325C16.8771 16.1062 17 15.8094 17 15.5V3.83333C17 3.52391 16.8771 3.22717 16.6583 3.00838C16.4395 2.78958 16.1428 2.66667 15.8333 2.66667ZM5.91667 3.83333V4.41667C5.91667 4.57138 5.97812 4.71975 6.08752 4.82915C6.19692 4.93854 6.34529 5 6.5 5C6.65471 5 6.80308 4.93854 6.91248 4.82915C7.02187 4.71975 7.08333 4.57138 7.08333 4.41667V3.83333H12.9167V4.41667C12.9167 4.57138 12.9781 4.71975 13.0875 4.82915C13.1969 4.93854 13.3453 5 13.5 5C13.6547 5 13.8031 4.93854 13.9125 4.82915C14.0219 4.71975 14.0833 4.57138 14.0833 4.41667V3.83333H15.8333V6.16667H4.16667V3.83333H5.91667ZM15.8333 15.5H4.16667V7.33333H15.8333V15.5Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.25 1.875C14.25 1.59886 14.0261 1.375 13.75 1.375C13.4739 1.375 13.25 1.59886 13.25 1.875V2.625H6.75V1.875C6.75 1.59886 6.52614 1.375 6.25 1.375C5.97386 1.375 5.75 1.59886 5.75 1.875V2.625H3.75C3.12868 2.625 2.625 3.12868 2.625 3.75V6.875V16.25C2.625 16.8713 3.12868 17.375 3.75 17.375H16.25C16.8713 17.375 17.375 16.8713 17.375 16.25V6.875V3.75C17.375 3.12868 16.8713 2.625 16.25 2.625H14.25V1.875ZM16.375 6.375V3.75C16.375 3.68096 16.319 3.625 16.25 3.625H14.25V4.375C14.25 4.65114 14.0261 4.875 13.75 4.875C13.4739 4.875 13.25 4.65114 13.25 4.375V3.625H6.75V4.375C6.75 4.65114 6.52614 4.875 6.25 4.875C5.97386 4.875 5.75 4.65114 5.75 4.375V3.625H3.75C3.68096 3.625 3.625 3.68096 3.625 3.75V6.375H16.375ZM3.625 7.375H16.375V16.25C16.375 16.319 16.319 16.375 16.25 16.375H3.75C3.68096 16.375 3.625 16.319 3.625 16.25V7.375Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CalendarBlankIcon;
